
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ExpShareButtonsComponent } from './exp-share-buttons.component';
import { ShareButtonsModule } from 'ngx-sharebuttons/buttons';
import { ShareIconsModule } from 'ngx-sharebuttons/icons';

@NgModule({
    imports: [
    CommonModule,
    ShareButtonsModule.withConfig({
        debug: true
    }),
    ShareIconsModule,
    ExpShareButtonsComponent
],
    exports: [
        ExpShareButtonsComponent
    ]
})
export class ExpShareButtonsModule { }
